import { useEffect } from "react";

const Redirect = ( props ) => {
   const { url } = props
   useEffect(() => {
      window.location.href = url;
   }, [url]);
};

export default Redirect;